// extracted by mini-css-extract-plugin
var _1 = "Otpinput-module__containerStyle__ik3Zd";
var _2 = "Otpinput-module__inputStyle__Bqakq";
export { _1 as "containerStyle", _2 as "inputStyle" }
